<template>
  <div class="enterpriseAndCommonality">
    <el-dialog
      width="600px"
      title="采购计划"
      :visible.sync="isDialogShow"
      :close-on-click-modal="false"
      show-close
    >
      <div class="bidPlan">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="130px"
          class="contactsForm"
        >
          <div class="bidPlanContent">
            <el-row>
              <el-col :span="24">
                <el-form-item
                  label="响应/报价单位："
                  prop="companyName"
                >
                  <el-select
                    v-model="ruleForm.companyName"
                    filterable
                    default-first-option
                    placeholder="请选择"
                    @change="changeType"
                  >
                    <el-option
                      v-for="item in companyList"
                      :key="item.id"
                      :label="item.companyName"
                      :value="item.companyName"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="报价" prop="offerPrice">
                  <el-input
                    v-model="ruleForm.offerPrice"
                    placeholder="请输入报价"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="报价单位">
                  <el-radio-group v-model="ruleForm.offerPriceUnit">
                    <el-radio
                      v-for="item in list"
                      :label="item.value"
                      :key="item.value"
                      style="width: 100px; margin: 10px 0"
                      >{{ item.name }}</el-radio
                    >
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="选拨情况说明">
                  <el-input
                    type="textarea"
                    :rows="4"
                    placeholder="请输入内容"
                    v-model="ruleForm.bidRemark"
                    maxlength="5000"
                    size="medium"
                    show-word-limit
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form>
        <div class="bottomBtn">
          <el-button type="primary" @click="submitBtn('ruleForm')"
            >保 存</el-button
          >
          <el-button type="info" @click="isDialogShow = false">取 消</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getValidSupplierAList, //获取有效供应商列表接口 aType：甲方，bType：乙方
} from "@/services/supplierMagServices";
export default {
  name: "bidPlan",
  data() {
    return {
      isDialogShow: false, //弹窗是否可见
      editFlag: true,
      RouteParam: {}, //存储路由跳转参数
      supplierId: 0, //总包合同ID
      dialogVisible: false, //预览图片是否异步
      dialogImageUrl: "", //预览图片的路径
      workPhone: "",
      legalPerson: "",
      companyList: [], //乙方供应商列表
      ruleForm: {
        ids: "", //id
        // typeKey: "", //typeKey
        // typeValue: "", //typeValue
        // companyNameId: null,
        companyName: '',
        offerPrice: null,
        offerPriceUnit: 1, //projectItemName
        bidRemark: "", //bidRemark
      },
      list: [
        {
          value: 1,
          name: "万元",
        },
        {
          value: 0,
          name: "元",
        },
      ],
      rules: {
        companyName: [
          { required: true, message: "请选择响应/报价单位", trigger: "change" },
        ],
        // projectItemName: [
        //   { required: true, message: "请填写工程分项名称", trigger: "blur" },
        // ],
        // bidRemark: [
        //   { required: true, message: "请输入说明", trigger: "blur" },
        // ],
        offerPrice: [
          { required: true, message: "请填写报价", trigger: "blur" },
          ,
          {
            pattern: /^[0-9,.]+$/,
            message: "只能输入数字",
            trigger: "change",
          },
        ],
      },
      isShopNameBool: false,
    };
  },
  components: {},
  mounted() {
    this.getcompanyList(); // 获取所有乙方供应商列表
  },
  methods: {
    showDialog(row) {
      if (row) {
        this.ruleForm = row;
      }
      this.isDialogShow = true;
      // this.getSupplierEvaluateDetail(Id);
    },
    //获取采购计划类型下拉框数据
    //获取所有乙方供应商列表
    getcompanyList() {
      let reqParam = {
        topType: "bType", //乙方供应商
        pageIndex: 1,
        pageSize: -1,
      };
      getValidSupplierAList(reqParam)
        .then((res) => {
          if (res.code == 10000000) {
            this.companyList = res.data;
          } else {
            if (res.code > 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          }
        })
        .catch((error) => {
          this.$message.error("系统异常");
        });
    },
    //切换类型
    changeType(val) {
      console.log(val)
      // let index = this.companyList.findIndex(
      //   (item) => item.id === this.ruleForm.companyNameId
      // );
      // if (index !== -1) {
      //   // this.ruleForm.typeKey = this.typeOption[index].label;
      //   this.ruleForm.companyName = this.companyList[index].companyName;
      // }
    },

    //提交
    submitBtn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$emit("submitBtn", this.ruleForm);
          this.isDialogShow = false;
          this.$refs.ruleForm.clearValidate();
          this.ruleForm = {
            ids: "", //id
            companyNameId: null,
            partBName: '',
            offerPrice: null,
            offerPriceUnit: 1, //projectItemName
            bidRemark: "", //bidRemark
          };
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.enterpriseAndCommonality {
  background-color: white;

  // height: 100%;
}
/deep/.el-table .cell {
  white-space: pre-line;
}
/deep/.el-dialog__body {
  padding: 10px 20px;
}

/deep/.el-popover {
  padding: 24px;
}

.bidPlan {
  width: 100%;
}
@media only screen and(max-width:1680px) {
  .bidPlan {
    width: 100%;
  }
}
.bidPlan {
  background: rgba(255, 255, 255, 1);
  .el-form-item {
    width: 100%;
  }
  /deep/.cell .el-form-item__content {
    margin-left: 10px !important;
  }
  /deep/.el-form-item {
    margin-bottom: 20px;
  }

  .el-checkbox {
    line-height: 40px;
  }

  .el-textarea {
    min-width: 0px !important;
  }
  .el-cascader {
    width: 100%;
  }

  .el-form-item__content {
    width: calc(100% - 110px);
    line-height: 20px;

    .el-input {
      width: 100%;
    }
    .el-select {
      width: 100%;
    }
  }
  .bottomBtn {
    // border-top: 1px solid #e6e6e6;
    width: 90%;
    height: 60px;
    line-height: 60px;
    text-align: center;
    margin-bottom: 20px;
  }
  .bidPlanTitle {
    height: 44px;
    padding-left: 24px;
    box-shadow: 0px 1px 0px 0px rgba(238, 238, 238, 1);
    border-radius: 2px 2px 0px 0px;
    font-size: 15px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
    line-height: 44px;
    text-align: left;
  }
  .bidPlanContent {
    padding: 14px 8px;
  }
  /deep/.daterangePicker {
    width: 255px;
    height: 32px;
    .el-input__icon {
      display: flex;
      align-items: center;
    }
    .el-range-separator {
      display: flex;
      align-items: center;
    }
  }
}
</style>
